if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (!this.form) return;

      const variantInput = this.form.querySelector('[name="id"]');
      if (variantInput) variantInput.disabled = false;

      this.form.addEventListener('submit', () => {
        let returnTo = this.form.querySelector('input[name="return_to"]');
        if (!returnTo) {
          returnTo = document.createElement('input');
          returnTo.type = 'hidden';
          returnTo.name = 'return_to';
          this.form.appendChild(returnTo);
        }
        returnTo.value = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
      });

      this.enhanceGhostDustVariantLabels();
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;

      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage && this.errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    enhanceGhostDustVariantLabels() {
      if (!window.location.pathname.includes('/products/ghost-dust-hair-texturizing-powder')) return;

      const variantRadios = document.querySelector('variant-radios');
      if (!variantRadios) return;

      const json = variantRadios.querySelector('script[type="application/json"]');
      if (!json) return;

      let variants = [];
      try {
        variants = JSON.parse(json.textContent || '[]');
      } catch (error) {
        return;
      }

      const isSpanish = (document.documentElement.lang || '').toLowerCase().startsWith('es');

      variantRadios.querySelectorAll('input[type="radio"]').forEach((input) => {
        const label = input.nextElementSibling;
        if (!label || label.tagName !== 'LABEL') return;

        const variant = variants.find((item) => Array.isArray(item.options) && item.options[0] === input.value);
        if (!variant) return;

        let optionName = input.value;
        if (input.value === 'hair product') {
          optionName = isSpanish ? '1 Producto para el Cabello' : '1 Hair Product';
        } else if (input.value === '3 hair products') {
          optionName = isSpanish ? '3 Productos para el Cabello' : '3 Hair Products';
        }

        const formattedPrice = `$${(Number(variant.price) / 100).toFixed(2)}`;
        label.textContent = `${optionName} — ${formattedPrice}`;
      });
    }
  });
}
